const ROLLOUTS = {
    GIG_IDS_REDIS: 'foxes_gig_page_ids_redis',
    LIONS_PROMOTE_LOCAL_SITES: 'lions_promote_local_sites',
    CHAM_V5_GIG_PAGE_VIEWS_FLOW: 'cham_v_five_gig_page_views_flow',
    QUAL_REVIEWS_WORK_SAMPLE_WEB_MOBILE: 'qualas_reviews_work_sample_web_mobile',
    GIG_PAGE_SBSS_INDICATION: 'qualas_gig_page_sbss_indication',
    FOXES_CREATE_BRIEF: 'foxes_create_new_brief_page',
    GIG_WORKFLOW_IN_GIG_EDIT: 'gig_workflow_in_gig_edit',
    GIG_WORKFLOW_IN_GIG_PAGE: 'gig_workflow_in_gig_page',
    FOXES_CONTACT_SELLER_OPTIONS: 'foxes_contact_seller_options',
    PUMAS_NOTABLE_CLIENTS_GIG_PAGE_ROLLOUT: 'notable_clients_gig_page',
    CHAM_GROWTH_CAROUSEL_EXTERNAL_VISITS: 'cham_growth_carousel_external_visits',
    GOATS_GIG_PAGE_STICKY_CTA: 'goats_gig_page_sticky_cta',
    QUALAS_REVIEWS_SBSS_INDICATION: 'qualas_reviews_sbss_indication',
    LIONS_FINAL_PRICE_UPFRONT: 'lions_final_price_upfront',
    QUALAS_REVIEWS_BUSINESS_FILTER_AND_INDICATION: 'qualas_reviews_business_filter_and_indication',
    GIG_PAGE_BASE_DATA_ENDPOINT: 'gig_page_base_data_endpoint',
    GIG_WORK_PROCESS_SELLERS: 'gig_work_process_sellers',
    GIG_WORK_PROCESS_BUYERS: 'gig_work_process_buyers'
};

const ROLLOUT_STATUS = {
    CLOSED: 0,
    ACTIVE: 1
};

module.exports = {
    ROLLOUTS,
    ROLLOUT_STATUS
};
